const wrapper = "_275wmznu6v";
const icon = "_275i1acarpp";
const badge = "_275b7xig50";

export { badge, icon, wrapper };
import "./icon.dialog.style.linaria.module.css";
//# sourceMappingURL=icon.dialog.style.js.map
